import { DeviceAvailability, Image, PickedEvent, ItemState } from "..";
import { observable, action, computed } from "mobx";

export interface IDeviceAvailability {
    AllowDevices: DeviceAvailability;
}
export enum LoginRestriction {
    LoggedInOnly = 2,
    LoggedOutOnly = 1,
    All = 0
}

export type SuperBannerItemType = {
    AllowDevices: DeviceAvailability;
    FreeHtmlText: string;
    Id: number;
    Image?: Image;
    Link?: string;
    LoginControl: LoginRestriction;
    Name: string;
    PickedEvent?: PickedEvent;
    SportId: number;
}

export class SuperBannerItem implements IDeviceAvailability {
    AllowDevices: DeviceAvailability;
    FreeHtmlText: string;
    Id: number;
    Image?: Image;
    Link?: string;
    LoginControl: LoginRestriction;
    Name: string;
    SportId : number;
    @observable PickedEvent?: PickedEvent;
    @observable state: ItemState;

    constructor(source: SuperBannerItemType) {
        this.AllowDevices = source.AllowDevices;
        this.FreeHtmlText = source.FreeHtmlText;
        this.Id = source.Id;
        this.Image = source.Image ? new Image(source.Image) : undefined;
        this.Link = source.Link;
        this.LoginControl = source.LoginControl || 0;
        this.Name = source.Name;
        this.PickedEvent = source.PickedEvent ? new PickedEvent(source.PickedEvent) : undefined;
        this.state = ItemState.unavailable;
        this.SportId = source.SportId;
    }

    /* istanbul ignore next */
    @action.bound setState(state: ItemState): void {
        this.state = state;
    }

    /* istanbul ignore next */
    @computed get IsLoading(): boolean {
        /* istanbul ignore next */
        return (this.PickedEvent === undefined && this.state === ItemState.loading) ||
        (!!this.PickedEvent && this.PickedEvent.state === ItemState.loading);
    }
}